import React from "react";
import Header from "../../Components/Header";
import ParticlesShap from "../../Components/Particles";
import ColorPicker from "../../Components/ColorPicker";
import * as S from "./style";
import * as T from "../../Components/Typography";
import * as I from "../../Components/Icons";
export default function Home() {
  return (
    <S.Wrapper>
      <S.Overlay>
        <ParticlesShap />
        <ColorPicker />
        <S.Content>
          <T.H1>Welcome</T.H1>
          <T.Head1>Maher Almashharawi</T.Head1>
          <S.Line />
          <T.P>
            A React Frontend Developer // Bring attractiveness and magics
          </T.P>
          <S.Line />
          <S.IconGroup>
            <I.Twitter />
            <I.UpWork />
            <I.Github />
            <I.LinkedIn />
          </S.IconGroup>
        </S.Content>
        <Header topclose />
      </S.Overlay>
    </S.Wrapper>
  );
}
